import api from "./api";

const PATH = "api/v1/novatra";

async function getCategories() {
  try {
    const res = await api.get(`${PATH}/categories`);
    return res.data.data || [];
  } catch (err) {
    return [];
  }
}

async function getBrands() {
  try {
    const res = await api.get(`${PATH}/brands`);
    return res.data.data || [];
  } catch (err) {
    return [];
  }
}

async function getUOMs() {
  try {
    const res = await api.get(`${PATH}/uoms`);
    return res.data.data || [];
  } catch (err) {
    return [];
  }
}

async function getTaxCategories() {
  try {
    const res = await api.get(`${PATH}/taxCategories`);
    return res.data.data || [];
  } catch (err) {
    return [];
  }
}

async function createCategory(payload) {
  const res = await api.post(`${PATH}/categories`, payload);
  return res.data.data;
}

async function createBrand(payload) {
  const res = await api.post(`${PATH}/brands`, payload);
  return res.data.data;
}

async function createUOM(payload) {
  const res = await api.post(`${PATH}/uoms`, payload);
  return res.data.data;
}

async function createTaxCategory(payload) {
  const res = await api.post(`${PATH}/taxCategories`, payload);
  return res.data.data;
}

export default {
  getCategories,
  getBrands,
  getUOMs,
  getTaxCategories,
  createCategory,
  createBrand,
  createUOM,
  createTaxCategory,
};
